onReady(($) => {
    const latestPosts = Array.from(document.querySelectorAll('.latest-posts'))
    for (const latestPost of latestPosts) {
        const ctaButton = latestPost.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => dataLayer.push({
            event: 'cta-click',
            interactionType: 'click',
            moduleName: latestPost.dataset.moduleName,
            elementContent: ctaButton.textContent.replace("\n", '')
                .trim(),
            elementType: ctaButton.nodeName,
            elementClasses: ctaButton.classList.toString(),
            destinationUrl: ctaButton.href,
            modulePosition: latestPost.dataset.modulePosition,
            distinctModulePosition: latestPost.dataset.distinctModulePosition,
            moduleTabPosition: latestPost.dataset.tabPosition,
            moduleId: latestPost.dataset.moduleId,
            wpLoggedIn: document.body.classList.contains('logged-in')
                .toString(),
        }))
    }
})
